import DiscoverSkeleton from './DiscoverSkeleton';

export default DiscoverSkeleton;
